import React, { Component } from 'react';
import { BrowserRouter, Route, Link, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Master from './components/master';

const Loading = () => (<h3 className="pagina" style={{ textAlign: "center" }}>Carregando...</h3>);

let AsyncComponent = (Component) => {
    return (props) => (
        <Suspense fallback={<Loading />}>
            <Component {...props} />
        </Suspense>
    );
};

const QuestoesContainer = AsyncComponent(lazy(() => import('./screens/questoes/questoes-container')));
const Home = AsyncComponent(lazy(() => import('./screens/home/home')));
const Solicitante = AsyncComponent(lazy(() => import('./screens/solicitante/solicitante-container')));
const RespostaConvite = AsyncComponent(lazy(() => import('./screens/resposta-convite/resposta-convite')));
const Documentos = AsyncComponent(lazy(() => import('./screens/documentos/')));
const ProjetoRefeicoes = AsyncComponent(lazy(() => import('./screens/projeto-refeicoes/')));
const ProjetoArrecadacoes = AsyncComponent(lazy(() => import('./screens/projeto-arrecadacoes/')));

var Erro404 = () => (<h2>Página não encontrada</h2>);



class Rotas extends Component {
    render() {
        return (
            <BrowserRouter basename='/Anjos/'>
                <Master>
                    <Switch>
                        <Route exact path="/" component={Home} />
                        <Route exact path="/ficha-inscricao" component={QuestoesContainer} />
                        <Route exact path="/solicitar-voluntarios" component={Solicitante} />                        
                        <Route exact path="/convite/RespostaConvite" component={RespostaConvite} />      
                        <Route exact path="/documentos" component={Documentos} />
                        <Route exact path="/projeto-refeicao-anjos-unoeste" component={ProjetoRefeicoes} />
                        <Route exact path="/arrecadacao-alimentos-anjos-unoeste" component={ProjetoArrecadacoes} />
                        

                        <Route component={Erro404} />
                    </Switch>
                </Master>
            </BrowserRouter>
        );
    }
};


export default Rotas;
